import type { i18n as I18n, TFunction } from 'i18next';

function websiteDictionary(i18n: I18n): Record<string, string> {
  const lng = i18n.resolvedLanguage ?? i18n.language;
  const bundle = i18n.getResourceBundle(lng, 'translation');
  if (bundle && typeof bundle === 'object') {
    return bundle as Record<string, string>;
  }

  for (const fallback of i18n.languages ?? []) {
    const fallbackBundle = i18n.getResourceBundle(fallback, 'translation');
    if (fallbackBundle && typeof fallbackBundle === 'object') {
      return fallbackBundle as Record<string, string>;
    }
  }

  return {};
}

/** Legacy `Utilities.TranslateByKey` for live period codes (WebsiteTranslates). */
export function translatePeriodLabel(key: string, t: TFunction, i18n: I18n): string {
  const trimmed = key.trim();
  if (!trimmed) return trimmed;

  const translated = websiteDictionary(i18n)[trimmed];
  if (typeof translated === 'string' && translated.length > 0) {
    return translated;
  }

  return t(trimmed, { defaultValue: trimmed });
}
